<div class="text">
	@if (entry.labelTranslate) {
		<span class="h3" [ngClass]="entry.labelClasses" [translate]="entry.labelTranslate"></span>
	}
	@if (!entry.labelTranslate) {
		<span class="h3" [ngClass]="entry.labelClasses">{{ entry.label }}</span>
	}
	<div class="info">
		@if (!entry.secondLineTranslate) {
			<span class="h6">{{ entry.secondLine }}</span>
		}
		@if (entry.secondLineTranslate) {
			<span class="h6" translate="{{ entry.secondLineTranslate }}"></span>
		}
		<div class="ico-size" [ngClass]="iconClass">
			<i class="ico"></i>
			<i class="ico"></i>
			<i class="ico"></i>
		</div>
	</div>
</div>
